/* ============================================================
   hæld — product variant selection
   Reads the option radios, matches a variant, and updates the
   hidden variant id, price, ?variant= URL param, and the
   add-to-cart button (pre-order aware).
   ============================================================ */
(function () {
  // ---- "Size guide" link → open + scroll to the size-guide accordion row ----
  document.querySelectorAll('[data-size-guide-open]').forEach(function (link) {
    link.addEventListener('click', function () {
      var panel = document.querySelector('[data-size-guide]');
      if (!panel) return;
      panel.open = true;
      panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });

  // ---- PDP quantity stepper ----
  // The input is a real number field, so this only adds nicer hit targets on
  // top of behaviour that already works without it.
  document.querySelectorAll('[data-qty-step]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = document.querySelector('[data-qty-input]');
      if (!input) return;
      var min = Number(input.min) || 1;
      var next = (Number(input.value) || min) + Number(btn.dataset.qtyStep);
      input.value = Math.max(min, next);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  // ---- AJAX add-to-cart + confirmation panel ----
  // Without this, every add is a native POST that navigates to /cart, so the
  // shopper loses the gallery, the size guide and the proof strip they were
  // reading. The form keeps working natively if any of this is unavailable —
  // we only call preventDefault once we know we can handle it ourselves.
  (function () {
    var panel = document.querySelector('[data-cart-panel]');
    var form = document.getElementById('product-form');
    if (!panel || !form || !window.fetch) return;

    var addUrl = panel.getAttribute('data-cart-add-url') || '/cart/add';
    var card = panel.querySelector('.cartpanel-card');
    var errEl = panel.querySelector('[data-cart-error]');
    var addBtn = document.querySelector('[data-add-button]');
    var barBtn = document.querySelector('[data-buybar-add]');
    var lastFocus = null;

    function setBusy(busy) {
      [addBtn, barBtn].forEach(function (b) {
        if (!b) return;
        b.classList.toggle('is-busy', busy);
        // Don't re-enable a button that was disabled for its own reasons.
        if (busy) b.setAttribute('aria-busy', 'true');
        else b.removeAttribute('aria-busy');
      });
    }

    function openPanel() {
      lastFocus = document.activeElement;
      panel.hidden = false;
      // Flush layout so the transition has a start state to animate from.
      // Deliberately a forced reflow rather than requestAnimationFrame: rAF is
      // suspended in a backgrounded tab, so a shopper who switched away mid-add
      // would come back to a panel that never slid in and an invisible dialog
      // holding focus.
      void panel.offsetWidth;
      panel.classList.add('is-open');
      card.focus();
      document.addEventListener('keydown', onKeydown);
    }

    function closePanel() {
      panel.classList.remove('is-open');
      document.removeEventListener('keydown', onKeydown);

      // Move focus out before the panel is hidden — focus left on a hidden
      // element is dropped to the document, which sends a keyboard or screen
      // reader user back to the top of the page. document.activeElement can be
      // <body> (an Enter-key submit, say), which is not focusable, so fall back
      // to whichever buy button is actually on screen.
      var target = lastFocus;
      if (!target || typeof target.focus !== 'function' ||
          target === document.body || !document.contains(target)) {
        target = (barBtn && barBtn.offsetParent !== null) ? barBtn : addBtn;
      }
      if (target && typeof target.focus === 'function') target.focus();

      var done = function () { panel.hidden = true; };
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) done();
      else window.setTimeout(done, 280);
    }

    function onKeydown(e) {
      if (e.key === 'Escape') { closePanel(); return; }
      if (e.key !== 'Tab') return;
      // Keep tabbing inside the dialog while it is modal.
      var f = card.querySelectorAll('a[href], button:not([disabled])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    panel.querySelectorAll('[data-cart-close]').forEach(function (el) {
      el.addEventListener('click', closePanel);
    });

    function setText(sel, value) {
      var el = panel.querySelector(sel);
      if (el) el.textContent = value || '';
    }

    // Defined in global.js so the cart page and this panel share one copy.
    function updateBadge(count) {
      if (window.haeld && window.haeld.setCartCount) window.haeld.setCartCount(count);
    }

    function showError(msg) {
      if (!errEl) return;
      errEl.textContent = msg;
      errEl.hidden = false;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (errEl) errEl.hidden = true;
      setBusy(true);

      var body = new FormData(form);
      fetch(addUrl + '.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: body
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw new Error(data.description || data.message || 'That size could not be added.');
            return data;
          });
        })
        .then(function (item) {
          var img = panel.querySelector('[data-cart-img]');
          if (img) {
            if (item.image) { img.src = item.image; img.alt = item.product_title || ''; img.hidden = false; }
            else { img.hidden = true; }
          }
          setText('[data-cart-name]', item.product_title);
          // "Default Title" is Shopify's placeholder for single-variant products.
          var v = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
          var vEl = panel.querySelector('[data-cart-variant]');
          if (vEl) { vEl.textContent = v; vEl.hidden = !v; }
          setText('[data-cart-price]', formatMoney(item.final_line_price != null ? item.final_line_price : item.price));
          openPanel();
          return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js',
                       { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) { updateBadge(cart.item_count); })
            .catch(function () { /* badge is cosmetic — the add already succeeded */ });
        })
        .catch(function (err) {
          // Surface it rather than failing silently; the shopper can still use
          // the cart page directly.
          openPanel();
          showError(err.message || 'Something went wrong. Please try again.');
        })
        .then(function () { setBusy(false); });
    });

    // Shopify returns prices in cents; reuse the page's own formatting where we
    // can rather than reimplementing locale rules.
    function formatMoney(cents) {
      if (cents == null) return '';
      var sample = document.querySelector('[data-price]');
      var amount = (cents / 100).toFixed(2);
      if (sample && sample.textContent) {
        var txt = sample.textContent.trim();
        var m = txt.match(/^([^\d]*)[\d.,\s]+([^\d]*)$/);
        if (m) {
          var usesComma = /\d,\d{2}\s*$/.test(txt) || /,\d{2}$/.test(txt.replace(/\s/g, ''));
          if (usesComma) amount = amount.replace('.', ',');
          return (m[1] || '') + amount + (m[2] || '');
        }
      }
      return amount;
    }
  })();

  // ---- sticky buy bar: reveal once the real buy box has scrolled off the top ----
  // Deliberately not shown while the buy box is still below the fold — a CTA that
  // appears before you have seen the actual one is just noise. CSS hides the bar
  // entirely above 860px, where .product-info is already sticky.
  (function () {
    var bar = document.querySelector('[data-buybar]');
    var anchor = document.querySelector('[data-add-button]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;

    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var scrolledPast = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', scrolledPast);
        bar.setAttribute('aria-hidden', String(!scrolledPast));
      });
    }, { threshold: 0 }).observe(anchor);
  })();

  document.querySelectorAll('[data-product-form]').forEach(function (root) {
    var dataEl = root.querySelector('[data-variant-json]');
    var idInput = root.querySelector('[data-variant-id]');
    var addBtn = root.querySelector('[data-add-button]');
    var addLabel = root.querySelector('[data-add-label]');
    var priceEl = root.querySelector('[data-price]');
    var groups = root.querySelectorAll('.variant-group');

    // Sticky-bar mirrors. Single-variant products never call update(), but their
    // server-rendered values are already correct and cannot change.
    var bar = document.querySelector('[data-buybar]');
    var barPrice = bar && bar.querySelector('[data-buybar-price]');
    var barSize = bar && bar.querySelector('[data-buybar-size]');
    var barBtn = bar && bar.querySelector('[data-buybar-add]');
    var barLabel = bar && bar.querySelector('[data-buybar-label]');

    // Single-variant products have no option groups — nothing to match.
    if (!dataEl || !idInput || !addBtn || !groups.length) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var isPreorder = root.getAttribute('data-preorder') === 'true';
    var labels = {
      add: root.getAttribute('data-label-add') || 'Add to cart',
      preorder: root.getAttribute('data-label-preorder') || 'Pre-order',
      soldout: root.getAttribute('data-label-soldout') || 'Sold out',
      unavailable: root.getAttribute('data-label-unavailable') || 'Unavailable'
    };

    function setLabel(text) { if (addLabel) addLabel.textContent = text; }

    function selectedOptions() {
      var opts = [];
      groups.forEach(function (group) {
        var checked = group.querySelector('input:checked');
        if (checked) {
          opts[Number(checked.getAttribute('data-option-index'))] = checked.value;
          var out = group.querySelector('[data-selected-label]');
          if (out) out.textContent = checked.value;
        }
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      })[0];
    }

    // Keep the sticky bar showing exactly what the real buy box shows.
    function mirror() {
      if (!bar) return;
      if (barLabel && addLabel) barLabel.textContent = addLabel.textContent;
      if (barBtn) barBtn.disabled = addBtn.disabled;
      if (barPrice && priceEl) barPrice.textContent = priceEl.textContent;
    }

    function update() {
      var opts = selectedOptions();
      if (barSize) barSize.textContent = opts.filter(Boolean).join(' / ');

      var v = findVariant(opts);
      if (!v) {
        idInput.value = '';
        addBtn.disabled = true;
        setLabel(labels.unavailable);
        mirror();
        return;
      }
      idInput.value = v.id;
      if (priceEl && v.price) priceEl.textContent = v.price;
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.href);
      } catch (e) { /* no-op */ }

      if (v.available) {
        addBtn.disabled = false;
        setLabel(isPreorder ? labels.preorder : labels.add);
      } else {
        addBtn.disabled = true;
        setLabel(labels.soldout);
      }
      mirror();
    }

    root.querySelectorAll('input[data-option-index]').forEach(function (inp) {
      inp.addEventListener('change', update);
    });
    update();
  });
})();
